import { render, staticRenderFns } from "./NewUnit.vue?vue&type=template&id=6091f0b2"
import script from "./NewUnit.vue?vue&type=script&lang=js"
export * from "./NewUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports